import { MDCLinearProgress } from '@material/linear-progress'

export default {
  setup() {
    this.linearProgress = new MDCLinearProgress(this.el)
  },
  destroy() {
    this.linearProgress?.destroy()
    this.linearProgress = null
  },
  mounted() {
    this.setup()
  },
  destroyed() {
    this.destroy()
  }
}
